import { useQuery } from 'react-query';
import { QUERY_KEY_BLOCKS, apiGetBloks } from 'api/blocks/apiGetBlocks';

export const useGetBlocks = (params = {}, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY_BLOCKS, params],
    queryFn: () => apiGetBloks(params),
    ...options,
  });
};
